import React, { FC } from 'react';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import { Box, IconButton, Typography } from '@mui/material';
import {
  FieldPathByValue,
  useFieldArray,
  useFormContext,
} from 'react-hook-form';
import { CustomFormulaValues } from 'src/components/Forms/CustomFormulaForm';
import { defaultOperators } from 'src/components/Forms/CustomFormulaForm/Filters/FilterCollapse';
import { Rule } from 'src/components/Forms/CustomFormulaForm/Filters/FilterCollapse/Rule';
import {
  AddButton,
  ConditionalDivider,
  GroupWrapper,
  InnerContainer,
  RuleBg,
  TitleContainer,
} from 'src/components/Forms/CustomFormulaForm/Filters/FilterCollapse/styled';
import { Filter, MetricFilterItem } from 'src/utils/gql/types';

interface RulesGroupProp {
  groupName: string;
  filters: Filter[];
  formulaItemIndex: number;
  filterItemIndex: number;
  loading: boolean;
  onDeleteGroup: () => void;
  firstKey: string;
  keySelection?: boolean;
  onChangeDimension: (key: string) => void;
}

export const RulesGroup: FC<RulesGroupProp> = ({
  groupName,
  filters,
  formulaItemIndex,
  filterItemIndex,
  loading,
  onDeleteGroup,
  keySelection,
  firstKey,
  onChangeDimension,
}) => {
  const { control } = useFormContext<CustomFormulaValues>();
  const filtersGroupPath: FieldPathByValue<
    CustomFormulaValues,
    MetricFilterItem[]
  > =
    `formulaItems.${formulaItemIndex}.filters.${filterItemIndex}.filtersGroup`;
  const { fields, append, remove } = useFieldArray({
    control,
    name: filtersGroupPath,
  });

  const handleAddRule = () =>
    append({ key: firstKey, operator: defaultOperators[0].key, values: [] });

  return (
    <GroupWrapper>
      <TitleContainer>
        <Typography>{groupName}</Typography>
        <IconButton onClick={onDeleteGroup}>
          <DeleteIcon />
        </IconButton>
      </TitleContainer>
      <InnerContainer>
        {fields.map((filter, index) => (
          <Box key={filter.id}>
            <RuleBg>
              <Rule
                onChangeDimension={onChangeDimension}
                keySelection={keySelection && !index}
                ruleName={`Rule ${index + 1}`}
                filterPath={`${filtersGroupPath}.${index}`}
                filters={filters}
                loading={loading}
                onDelete={() => remove(index)}
              />
            </RuleBg>
            {fields.length !== index + 1 && (
              <ConditionalDivider>AND</ConditionalDivider>
            )}
          </Box>
        ))}
      </InnerContainer>
      <AddButton onClick={handleAddRule}>
        <AddIcon />
        <Typography>Add rule</Typography>
      </AddButton>
    </GroupWrapper>
  );
};
